/**
 * Pure helpers for packing list stats (item count, trailer names by category).
 * Used by CreateTripDialog, EditTripDialog, CreateOperationDialog.
 */

import type { PackingListItem } from '../schema';
import { TRAILER_CATEGORY_NAME } from './tripPlanningConstants';

export function getPackingListStats(
    packingListItemsByEvent: Map<string, PackingListItem[]>,
    eventId: string
): { itemCount: number; trailerNames: string[] } {
    const items = packingListItemsByEvent.get(eventId) ?? [];
    const trailerNames = new Set<string>();
    for (const item of items) {
        const cat = item.itemType?.category?.name ?? '';
        if (cat === TRAILER_CATEGORY_NAME && item.itemType?.name) {
            trailerNames.add(item.itemType.name);
        }
    }
    return { itemCount: items.length, trailerNames: Array.from(trailerNames) };
}
